(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[6189],{

/***/ 56189:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ HomeFilter; }
});

// EXTERNAL MODULE: ./node_modules/.pnpm/react@18.2.0/node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(11527);
// EXTERNAL MODULE: ./node_modules/.pnpm/react-i18next@12.3.1_i18next@22.5.1_react-dom@18.2.0_react@18.2.0__react@18.2.0/node_modules/react-i18next/dist/es/index.js + 17 modules
var es = __webpack_require__(53218);
// EXTERNAL MODULE: ./node_modules/.pnpm/next@13.0.0_react-dom@18.2.0_react@18.2.0__react@18.2.0_sass@1.99.0/node_modules/next/link.js
var next_link = __webpack_require__(6339);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./node_modules/.pnpm/next@13.0.0_react-dom@18.2.0_react@18.2.0__react@18.2.0_sass@1.99.0/node_modules/next/router.js
var router = __webpack_require__(21867);
// EXTERNAL MODULE: ./node_modules/.pnpm/remixicon-react@1.0.0_react@18.2.0/node_modules/remixicon-react/FilterFillIcon.js
var FilterFillIcon = __webpack_require__(70282);
var FilterFillIcon_default = /*#__PURE__*/__webpack_require__.n(FilterFillIcon);
;// CONCATENATED MODULE: ./components/home-filter/filter.ts
const shopFilters = [
    {
        label: "near.you",
        value: {
            near: "1"
        }
    },
    {
        label: "open.now",
        value: {
            open: "1"
        }
    },
    {
        label: "24/7",
        value: {
            work_24_7: "1"
        }
    },
    {
        label: "new",
        value: {
            column: "created_at",
            sort: "desc"
        }
    }
];

// EXTERNAL MODULE: ./components/home-filter/home-filter.module.scss
var home_filter_module = __webpack_require__(59096);
var home_filter_module_default = /*#__PURE__*/__webpack_require__.n(home_filter_module);
;// CONCATENATED MODULE: ./components/home-filter/home-filter.tsx







function HomeFilter() {
    const { t  } = (0,es/* useTranslation */.$G)();
    const { query  } = (0,router.useRouter)();
    const handleFilter = (filterValue)=>{
        const tempQuery = {
            ...query
        };
        const filterKeys = new Set(shopFilters.flatMap((shopFilter)=>Object.keys(shopFilter.value)));
        Object.keys(tempQuery).forEach((tempKey)=>{
            if (filterKeys.has(tempKey)) {
                delete tempQuery[tempKey];
            }
        });
        return {
            ...tempQuery,
            ...filterValue
        };
    };
    const isShopFilterActive = (filterValue)=>{
        return Object.keys(filterValue).every((key)=>{
            return (query === null || query === void 0 ? void 0 : query[key]) === filterValue[key];
        });
    };
    const isAnyShopFilterActive = shopFilters.some((shopFilter)=>isShopFilterActive(shopFilter.value));
    const isActive = (filterValue)=>{
        return isShopFilterActive(filterValue) || !isAnyShopFilterActive && (filterValue === null || filterValue === void 0 ? void 0 : filterValue.near);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (home_filter_module_default()).container,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: (home_filter_module_default()).wrapper,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (home_filter_module_default()).filterIcon,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)((FilterFillIcon_default()), {
                        size: 20
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (home_filter_module_default()).tabs,
                    children: shopFilters.map((shopFilter)=>/*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: (home_filter_module_default()).tab,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                    href: {
                                        query: handleFilter(shopFilter.value)
                                    },
                                    className: "".concat((home_filter_module_default()).tabButton, " ").concat(isActive(shopFilter.value) ? (home_filter_module_default()).activeTab : ""),
                                    children: t(shopFilter.label)
                                }),
                                isActive(shopFilter.value) && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: (home_filter_module_default()).activeLine
                                })
                            ]
                        }, shopFilter.label))
                })
            ]
        })
    });
}


/***/ }),

/***/ 59096:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"home-filter_container__RLTLE","wrapper":"home-filter_wrapper__zu_ji","tabs":"home-filter_tabs__Wfh_4","filterIcon":"home-filter_filterIcon__sbUSj","tab":"home-filter_tab__2I9Nx","tabButton":"home-filter_tabButton__eRKwO","activeTab":"home-filter_activeTab__4piDM","activeLine":"home-filter_activeLine___cX0o"};

/***/ }),

/***/ 70282:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(50959);

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

var objectWithoutProperties = function (obj, keys) {
  var target = {};

  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }

  return target;
};

var FilterFillIcon = function FilterFillIcon(_ref) {
  var _ref$color = _ref.color,
      color = _ref$color === undefined ? 'currentColor' : _ref$color,
      _ref$size = _ref.size,
      size = _ref$size === undefined ? 24 : _ref$size,
      children = _ref.children,
      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);

  var className = 'remixicon-icon ' + (props.className || '');

  return React__default['default'].createElement(
    'svg',
    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
    React__default['default'].createElement('path', { d: 'M21 4L21 6 20 6 14 15 14 22 10 22 10 15 4 6 3 6 3 4z' })
  );
};

var FilterFillIcon$1 = React__default['default'].memo ? React__default['default'].memo(FilterFillIcon) : FilterFillIcon;

module.exports = FilterFillIcon$1;


/***/ })

}]);